import { motion, AnimatePresence } from "framer-motion";

export default function Paginacao({
  paginaAtual,
  setPaginaAtual,
  totalPaginas,
  setItensPorPagina,
  itensPorPagina,
}) {
  const mudarPagina = (pagina) => {
    if (pagina >= 1 && pagina <= totalPaginas) {
      setPaginaAtual(pagina);
      // 👇 forçamos rolar pro topo da tabela sempre que trocar de página
      const tabela = document.querySelector("table");
      if (tabela) {
        tabela.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  // 🔹 Gerar páginas (máx 6 exibidas)
  const gerarPaginas = () => {
    let paginas = [];
    let inicio = Math.max(1, paginaAtual - 2);
    let fim = Math.min(totalPaginas, inicio + 5);

    if (fim - inicio < 5) {
      inicio = Math.max(1, fim - 5);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  };

  return (
    <div className="flex items-center justify-center gap-1 p-2 bg-[#2b2b2b] text-white">
      {/* Primeira página */}
      <button
        onClick={() => mudarPagina(1)}
        disabled={paginaAtual === 1 || itensPorPagina === Infinity}
        className="px-3 py-1 bg-[#1f1f1f] border border-slate-600 rounded-sm disabled:opacity-40"
      >
        ««
      </button>

      {/* Página anterior */}
      <button
        onClick={() => mudarPagina(paginaAtual - 1)}
        disabled={paginaAtual === 1 || itensPorPagina === Infinity}
        className="px-3 py-1 bg-[#1f1f1f] border border-slate-600 rounded-sm disabled:opacity-40"
      >
        ‹
      </button>

      {/* Números das páginas */}
      {itensPorPagina !== Infinity &&
        gerarPaginas().map((p) => (
          <motion.button
            key={p}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => mudarPagina(p)}
            className={`px-3 py-1 border rounded-sm transition-colors ${
              paginaAtual === p
                ? "bg-orange-600 border-orange-600 font-bold text-white"
                : "bg-[#2b2b2b] border-slate-600 hover:bg-[#3a3a3a]"
            }`}
          >
            {p}
          </motion.button>
        ))}

      {/* Próxima página */}
      <button
        onClick={() => mudarPagina(paginaAtual + 1)}
        disabled={paginaAtual === totalPaginas || itensPorPagina === Infinity}
        className="px-3 py-1 bg-[#1f1f1f] border border-slate-600 rounded-sm disabled:opacity-40"
      >
        ›
      </button>

      {/* Última página */}
      <button
        onClick={() => mudarPagina(totalPaginas)}
        disabled={paginaAtual === totalPaginas || itensPorPagina === Infinity}
        className="px-3 py-1 bg-[#1f1f1f] border border-slate-600 rounded-sm disabled:opacity-40"
      >
        »»
      </button>

      {/* Ver todos / Voltar */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          if (itensPorPagina === Infinity) {
            setItensPorPagina(10); // volta para paginação normal
            setPaginaAtual(1);
          } else {
            setItensPorPagina(Infinity); // mostra todos
            setPaginaAtual(1);
          }
          const tabela = document.querySelector("table");
          if (tabela) {
            tabela.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }}
        className="ml-2 px-4 py-1 bg-blue-600 hover:bg-blue-700 rounded-sm font-semibold"
      >
        {itensPorPagina === Infinity ? "Voltar" : "Ver todos"}
      </motion.button>
    </div>
  );
}
